/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type ProjectProduct = (typeof ProjectProduct)[keyof typeof ProjectProduct];

export const ProjectProduct = {
  external: 'external',
  internal: 'internal',
} as const;
